let module = angular.module('app.resources');

module.factory('Donation', function Donation($resource) {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/donations/:id`,
    { id: '@id' },
    {
      update: {
        method: 'PUT',
      },
      summary: {
        method: 'GET',
        url: `${API_ROOT}/account/donations/summary`,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/donation.js